class LocalStorageMock implements Storage {
  private readonly _storage = new Map<string, string>();

  public get length(): number {
    return this._storage.size;
  }

  public clear(): void {
    this._storage.clear();
  }

  public getItem(key: string): string | null {
    return this._storage.get(key) || null;
  }

  public key(index: number): string | null {
    return Array.from(this._storage.keys())[index] || null;
  }

  public removeItem(key: string): void {
    this._storage.delete(key);
  }

  public setItem(key: string, value: string): void {
    this._storage.set(key, value);
  }
}

export const SSRSupportedLocalStorage = typeof window !== 'undefined' ? window.localStorage : new LocalStorageMock();

export const getObjectFromLocalStorage = <T = Record<string, unknown>>(key: string): T | null => {
  const item = SSRSupportedLocalStorage.getItem(key);
  return item ? (JSON.parse(item) as T) : null;
};

export const setObjectToLocalStorage = <T = Record<string, unknown>>(key: string, value: T | null) => {
  if (value === null) {
    SSRSupportedLocalStorage.removeItem(key);
    return;
  }
  SSRSupportedLocalStorage.setItem(key, JSON.stringify(value));
};
